module.exports = __webpack_public_path__ + "TB_Warning_SFX_B.wav.3d5d6663.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_SFX_B.wav.mp3
// module id = 513
// module chunks = 0